import apiHeader from '@/helpers/apiHeader';

const clientService = {
    list(params) {
        return apiHeader.get('general-master-data/client', { params });
    },
    create(params) {
        return apiHeader.post('general-master-data/client', params);
    },
    detail(id) {
        return apiHeader.get(`general-master-data/client/${id}`);
    },
    patch(id, params) {
        return apiHeader.patch(`general-master-data/client/${id}`, params);
    },
    delete(id) {
        return apiHeader.delete(`general-master-data/client/${id}`);
    },
}

export default clientService;
